import apiSlice from "./apiSlice";
const keySafetySlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addKeySafety: builder.mutation({
      query: (body) => ({
        url: `safety`,
        method: "POST",
        body,
      }),
    }),
    editKeySafety: builder.mutation({
      query: ({ id, body }) => ({
        url: `/safety/${id}`,
        method: "PUT",
        body,
      }),
    }),
    deleteKeySafety: builder.mutation({
      query: (id, body) => ({
        url: `safety/${id}`,
        method: "DELETE",
        body,
      }),
    }),
    approveKeySafety: builder.mutation({
      query: ({ id }) => ({
        url: `/safety/${id}/approve`,
        method: "POST",
      }),
    }),
    rejectKeySafety: builder.mutation({
      query: ({ id, body }) => ({
        url: `/safety/${id}/reject`,
        method: "POST",
        body,
      }),
    }),
    updateWorkflowKeySafety: builder.mutation({
      query: (body) => ({
        url: `/safety/UpdateWorkFlow`,
        method: "POST",
        body,
      }),
    }),
    getSafety: builder.query({
      query: (req) => ({
        url: `Safety/${req}`,
      }),
    }),
  }),
});

export const {
  useAddKeySafetyMutation,
  useEditKeySafetyMutation,
  useDeleteKeySafetyMutation,
  useApproveKeySafetyMutation,
  useRejectKeySafetyMutation,
  useGetSafetyQuery,
  useUpdateWorkflowKeySafetyMutation
} = keySafetySlice;
